import { createContext, useContext } from 'react';

const CalendarYearContext = createContext<number | null>(null);

export const CalendarYearProvider = CalendarYearContext.Provider;

export const useCalendarYear = (): number => {
  const year = useContext(CalendarYearContext);
  return year ?? new Date().getFullYear();
};
